// @flow
import type { GroupClassesPeriodArchivePayload, GroupClassesPeriodArchive } from '@groupClass/types';

export const hydrateGroupClassesPeriodArchiveFromPayload = (payload: GroupClassesPeriodArchivePayload): GroupClassesPeriodArchive => ({
  id: payload.id,
  archivedAt: new Date(payload.archivedAt),
});
